import React, { useContext } from 'react';
import { Checkbox, Grid, InputLabel, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { DocumentosContext } from 'contexts/DocumentosContext';
import Button from 'components/Button';
import Input from 'components/Input';

const JustificativaModal = ({ documento_id, callback }) => {
  const defaultValues = { motivo: '', reabertura: true };
  const { control, handleSubmit, watch, setValue } = useForm({ defaultValues });
  const { postDocumento, postLoading } = useContext(DocumentosContext);
  const reabertura = watch('reabertura');

  const onSubmit = ({ motivo, reabertura }) => {
    const data = {
      Documento: {
        id: documento_id,
        conferido: 'NAO',
      },
      Registros: [{ documento_id, status_id: 2, motivo, reabertura }],
    };
    postDocumento({
      data,
      cb: () => {
        if (callback) {
          callback();
        }
      },
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" component="div" align="center">
          Informações Gerais
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Input
          name="motivo"
          control={control}
          label="Justificativa de cancelamento"
          multiline
          rows={10}
        />
      </Grid>
      <Grid item xs={12} display="flex" alignItems="center">
        <Checkbox
          id="reabertura"
          color="primary"
          checked={reabertura}
          label="Reabrir Documento de Origem"
          onChange={(_, v) => setValue('reabertura', v)}
        />
        <InputLabel htmlFor="reabertura">
          Reabrir Documento de Origem
        </InputLabel>
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          variant="contained"
          color="primary"
          loading={postLoading}
          onClick={handleSubmit(onSubmit)}
        >
          Salvar
        </Button>
      </Grid>
    </Grid>
  );
};

export default JustificativaModal;
